<template>
  <div class="d-flex align-center py-3 set-editable-row">
    <div class="flex-grow-1 text-body-1 font-weight-medium">
      {{ label }}
    </div>

    <v-text-field
      :value="startTimeText"
      type="time"
      step="300"
      hide-details
      outlined
      style="max-width: 140px;"
      class="set-input mr-3"
      @input="onStartTimeInput"
    />

    <v-text-field
      :value="price"
      type="number"
      hide-details
      outlined
      style="max-width: 140px;"
      class="set-input"
      @input="onPriceInput"
    />
    <span class="mx-2 text-body-1">円</span>

    <v-btn-toggle
      :value="taxCharge"
      mandatory
      class="ml-3 tax-charge-toggle"
      @change="$emit('update:taxCharge', $event)"
    >
      <v-btn
        large
        value="normal"
      >
        通常
      </v-btn>
      <v-btn
        large
        value="cut"
      >
        カット
      </v-btn>
    </v-btn-toggle>
  </div>
</template>

<script>
import { computed } from '@vue/composition-api'

const pad2 = n => String(n).padStart(2, '0')

export default {
  name: 'SetEditableRow',
  props: {
    label: { type: String, required: true },
    price: { type: Number, default: 0 },
    taxCharge: { type: String, default: 'normal' },
    startAt: { type: Date, default: null },
  },
  emits: ['update:price', 'update:taxCharge', 'update:startAt'],
  setup(props, { emit }) {
    const onPriceInput = v => {
      emit('update:price', Number(v) || 0)
    }

    const startTimeText = computed(() => {
      const d = props.startAt
      if (!(d instanceof Date)) return ''

      return `${pad2(d.getHours())}:${pad2(d.getMinutes())}`
    })

    const onStartTimeInput = v => {
      if (!v) return
      const [h, m] = v.split(':').map(Number)
      if (Number.isNaN(h) || Number.isNaN(m)) return
      const base = props.startAt instanceof Date ? new Date(props.startAt.getTime()) : new Date()
      base.setHours(h, m, 0, 0)
      emit('update:startAt', base)
    }

    return { onPriceInput, startTimeText, onStartTimeInput }
  },
}
</script>

<style scoped>
.set-editable-row {
  border-bottom: 1px solid rgba(127, 127, 127, 0.12);
}
.set-input :deep(input) {
  font-size: 1.1rem;
  text-align: right;
}
</style>
